module.exports = __webpack_public_path__ + "img/seo_gfish_item03.91329f6.webp";